export enum TipoOrdenacao {
  Crescente = 0,
  Decrescente = 1
}

export enum TipoOrdenacaoApi {
  Crescente = '',
  Decrescente = '_Desc'
}
